import { defineMessages } from 'react-intl';

export const ConfluenceTemplateMessages = defineMessages({
	templateTitle: {
		id: 'confluence.templates.detail.template.title',
		defaultMessage: '{templateName} template',
		description: "Template title, ex. 'Meeting notes template'",
	},
	templateAuthorByLine: {
		id: 'confluence.templates.detail.author.by',
		defaultMessage: 'by {author}',
		description: 'Author byline',
	},
	useTemplate: {
		id: 'confluence.templates.card.use-template',
		defaultMessage: 'Use template',
	},
	templateCategoriesLabel: {
		id: 'confluence.templates.categories.label',
		defaultMessage: 'Categories',
	},
	cardLearnMore: {
		id: 'confluence.templates.card.learn-more',
		defaultMessage: 'Learn more',
	},
	belongsToCollections: {
		id: 'confluence.templates.detail.belongs-to-collections',
		defaultMessage: 'Collections this template belongs to',
	},
	moreCollections: {
		id: 'confluence.templates.collection-details.more-collections',
		defaultMessage: 'More collections',
	},
	viewAllCollections: {
		id: 'confluence.templates.collection-details.view-all',
		defaultMessage: 'View all',
	},
	viewAllCollectionsLink: {
		id: 'confluence.templates.detail.collections-view-all',
		defaultMessage: 'View all',
	},
	viewAllCategoryTemplates: {
		id: 'confluence.templates.detail.category-view-all',
		defaultMessage: 'View all',
	},
	backToGallery: {
		id: 'confluence.templates.collection-details.back-to-gallery',
		defaultMessage: 'Back to template gallery',
	},
	collectionViewTemplate: {
		id: 'confluence.templates.collection-details.view-template',
		defaultMessage: 'View template',
	},
	moreTemplates: {
		id: 'confluence.templates.detail.more-templates',
		defaultMessage: 'More {category} templates',
	},
	searchInput: {
		id: 'confluence.templates.search.input.placeholder',
		defaultMessage: 'Search templates',
		description: 'Placeholder text for the confluence template search bar',
	},
	searchAriaLabel: {
		id: 'confluence.templates.search.submit',
		defaultMessage: 'Search',
		description: 'Aria label for the search button',
	},
	searchBackAriaLabel: {
		id: 'confluence.templates.search.back',
		defaultMessage: 'Back',
		description: 'Aria label for the back button',
	},
	carouselPreviousLabel: {
		id: 'confluence.templates.carousel.previous',
		defaultMessage: 'View previous',
	},
	carouselNextLabel: {
		id: 'confluence.templates.carousel.next',
		defaultMessage: 'View next',
	},
	fuzzySearchInputText: {
		id: 'confluence.templates.fuzzy.search.input.placeholder.text',
		defaultMessage: 'Search for Confluence templates',
		description: 'Placeholder text for the confluence template fuzzy search bar',
	},
	searchLabel: {
		id: 'confluence.templates.fuzzy.search.label',
		defaultMessage: 'Search',
	},
	closeLabel: {
		id: 'confluence.templates.fuzzy.close.label',
		defaultMessage: 'Close',
	},
	fuzzySearchAriaLabel: {
		id: 'confluence.templates.fuzzy.search.aria.label',
		defaultMessage: 'Search for Confluence templates',
		description: 'Aria label for the confluence template fuzzy search input',
	},
	templateAuthorBy: {
		id: 'confluence.templates.author.by',
		defaultMessage: 'By {author}',
		description: 'Author byline',
	},
	headerText: {
		id: 'confluence.main.area.title',
		defaultMessage: '{categoryName} Templates for Confluence',
		description: 'categoryName Templates for Confluence',
	},
	subHeaderText: {
		id: 'confluence.main.area.subHeaderText',
		defaultMessage: "Use Confluence to get a head start on your team's projects and docs.",
		description: 'subheader text for Confluence hero section',
	},
	loadMoreTemplatesButtonText: {
		id: 'confluence.templates.load.more.button.text',
		defaultMessage: 'Load more templates',
		description: 'Load More Templates button text',
	},
	noTemplatesAvailableText: {
		id: 'confluence.templates.no.templates.available.text',
		defaultMessage: 'No templates available.',
		description: 'No Templates available text',
	},
	defaultHeaderText: {
		id: 'confluence.main.area.default.header.text',
		defaultMessage: 'Templates for Confluence',
		description: 'Templates for Confluence header text',
	},
	additionalCategoriesText: {
		id: 'confluence.main.area.additional.categories.text',
		defaultMessage: 'Additional template categories',
		description: 'Templates Additional categories text',
	},
	relatedTemplatesTitle: {
		id: 'confluence.templates.related.templates.title',
		defaultMessage: 'Related Templates',
		description: 'Related templates title',
	},
	useTemplateButtonAriaText: {
		id: 'confluence.templates.useTemplate.button.aria.label',
		defaultMessage: 'Use {template}',
	},
});
